async function render () {
  const html = `
    <div class="banner"></div>
    
    <div class="container">
      <h1>About</h1>
      <p>
        Slowed was created by two brothers from a small island in south of Brazil. 
      </p>

      <p>
        Playing with music and pitch bending in cassettes, vinyls and cd players has been one of our hobbies recently.
      </p>

      <p>
        Unfortunetelly, this functionality has disappeared from modern media players such as Youtube and we wanted to bring it back.
      </p>

      <p>
        If you enjoyed, please support us by reviewing the app, sharing with your friends or <a href="/buycoffee">buy us a coffee</a>!
      </p>

      <br/><br/>
      
      <h2>Credits</h2>
      <p>
        We wanna thank all of the following open source projects used in the development of this extension.
      </p>

      <p>
        Without these people, Slowed wouldn't be as awesome!
      </p>

      <p>
        <a href="https://github.com/khoin/DattorroReverbNode">DattorroReverbNode</a> by <a href="https://github.com/khoin">@khoin</a>
      </p>

      <p>
        <code>
          In jurisdictions that recognize copyright laws, this software is to
          be released into the public domain.
          
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND.
          THE AUTHOR(S) SHALL NOT BE LIABLE FOR ANYTHING, ARISING FROM, OR IN
          CONNECTION WITH THE SOFTWARE OR THE DISTRIBUTION OF THE SOFTWARE.        
        </code>
      </p>

      <p>
        <a href="https://github.com/gyng/ditherer">Ditherer</a> by <a href="https://github.com/gyng">@gyng</a>
      </p>

      <p>
        <code>
          Copyright 2017 Ng Guoyou, contributors

          Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
          
          The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
          
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.      
        </code>
      </p>

      <p>
        <a href="https://github.com/Popmotion/popmotion">Popmotion</a> by <a href="https://github.com/framer">@framer</a>
      </p>
      <p>
        <code>
          The MIT License (MIT)

          Copyright © 2019 Framer BV

          Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

          The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
        </code>
      </p>
    </div>
  `

  document.getElementById('content').innerHTML = html
}

export async function init () {
  await render()
}
